<template>
 <div id="app">
 	<router-view v-wechat-title="$route.meta.title"></router-view>
 </div>
</template>

<script>

export default {
  name: 'app',
  components: {
   
  }
}
</script>

<style>
	
	@font-face {
	  font-family: 'Alibaba PuHuiTi';
	  font-display: swap;
	  src: url('//at.alicdn.com/t/webfont_eo5jtoflk96.eot'); /* IE9*/
	  src: url('//at.alicdn.com/t/webfont_eo5jtoflk96.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
	  url('//at.alicdn.com/t/webfont_eo5jtoflk96.woff2') format('woff2'),
	  url('//at.alicdn.com/t/webfont_eo5jtoflk96.woff') format('woff'), /* chrome、firefox */
	  url('//at.alicdn.com/t/webfont_eo5jtoflk96.ttf') format('truetype'), /* chrome、firefox、opera、Safari, Android, iOS 4.2+*/
	  url('//at.alicdn.com/t/webfont_eo5jtoflk96.svg#Alibaba-PuHuiTi-Regular') format('svg'); /* iOS 4.1- */
	}
	
	@font-face {
	  font-family: 'Alibaba-PuHuiTi-M';
	  font-display: swap;
	  src: url('//at.alicdn.com/t/webfont_2808ykgjzd7.eot'); /* IE9*/
	  src: url('//at.alicdn.com/t/webfont_2808ykgjzd7.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
	  url('//at.alicdn.com/t/webfont_2808ykgjzd7.woff2') format('woff2'),
	  url('//at.alicdn.com/t/webfont_2808ykgjzd7.woff') format('woff'), /* chrome、firefox */
	  url('//at.alicdn.com/t/webfont_2808ykgjzd7.ttf') format('truetype'), /* chrome、firefox、opera、Safari, Android, iOS 4.2+*/
	  url('//at.alicdn.com/t/webfont_2808ykgjzd7.svg#AlibabaPuHuiTiM') format('svg'); /* iOS 4.1- */
	}
	
	@font-face {
	  font-family: 'Alibaba-PuHuiTi-R';
	  font-display: swap;
	  src: url('//at.alicdn.com/t/webfont_bep7d5ok8u.eot'); /* IE9*/
	  src: url('//at.alicdn.com/t/webfont_bep7d5ok8u.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
	  url('//at.alicdn.com/t/webfont_bep7d5ok8u.woff2') format('woff2'),
	  url('//at.alicdn.com/t/webfont_bep7d5ok8u.woff') format('woff'), /* chrome、firefox */
	  url('//at.alicdn.com/t/webfont_bep7d5ok8u.ttf') format('truetype'), /* chrome、firefox、opera、Safari, Android, iOS 4.2+*/
	  url('//at.alicdn.com/t/webfont_bep7d5ok8u.svg#Alibaba-PuHuiTi-Regular') format('svg'); /* iOS 4.1- */
	}
	
	* {
		font-family: Alibaba-PuHuiTi-R;
	}
	
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}
*{
	margin: 0;
	padding: 0;
}
@font-face {
	  font-family: 'iconfont';  /* project id 1631181 */
	  src: url('//at.alicdn.com/t/font_1631181_hmaf9or4mwi.eot');
	  src: url('//at.alicdn.com/t/font_1631181_hmaf9or4mwi.eot?#iefix') format('embedded-opentype'),
	  url('//at.alicdn.com/t/font_1631181_hmaf9or4mwi.woff2') format('woff2'),
	  url('//at.alicdn.com/t/font_1631181_hmaf9or4mwi.woff') format('woff'),
	  url('//at.alicdn.com/t/font_1631181_hmaf9or4mwi.ttf') format('truetype'),
	  url('//at.alicdn.com/t/font_1631181_hmaf9or4mwi.svg#iconfont') format('svg');
	}

	.iconfont {
		font-family: 'iconfont';
	}
</style>
